import { useTranslation } from 'react-i18next'
// eslint-disable-next-line lodash/import-scope
import _ from 'lodash'

import { Reports } from '../../../containers/CompanyDetail/Reports'
import { Company } from '../../../redux/companyDetail/types'

import { formatRegistrationNumber } from '../../utils/fieldUtils'

import { maxDayRenderDeliveryOptionLabel } from '../../utils/config'

import { CompanyDetailPageConfig, CompanyDetailFields, defaultFormatAddress } from './config'

export function useCompanyDetailPageConfig(): CompanyDetailPageConfig {
  const { t } = useTranslation('companyDetail')

  return {
    generateFields: (c: Company) => {
      const ret: CompanyDetailFields = {
        notAuthFields: _.filter(
          [
            {
              label: t('UEN'),
              value: formatRegistrationNumber(c)
            },
            {
              label: t('Status'),
              value: c.status ?? ''
            },
            {
              label: t('FormerName'),
              value: c.formerName ?? ''
            }
          ],
          x => !_.isEmpty(x.value)
        ),
        authFields: []
      }

      return ret
    },
    tabs: [
      {
        key: 1,
        title: t('Tabs.Reports'),
        component: Reports,
        componentProps: {
          renderDeliveryOptionLabel: maxDayRenderDeliveryOptionLabel
        }
      },
      {
        key: 2,
        title: t('Tabs.Financial')
      },
      {
        key: 3,
        title: t('Tabs.CompanyNetwork')
      },
      {
        key: 4,
        title: t('Tabs.Industry')
      }
    ],
    formatAddress: defaultFormatAddress
  }
}
